import { Link } from "react-router-dom";
import { brand, stats } from "@/mocks/site";

export default function HomeHero() {
  return (
    <section className="relative w-full overflow-hidden bg-background-50">
      <div className="pointer-events-none absolute inset-0 paper-grain opacity-60"></div>
      <div className="relative mx-auto grid w-full grid-cols-1 gap-10 px-4 pb-14 pt-12 md:px-6 md:pb-20 md:pt-16 lg:grid-cols-12 lg:gap-12 lg:pt-20">
        <div className="flex flex-col justify-center lg:col-span-7 animate-fade-up">
          <span className="inline-flex w-fit items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3.5 py-1.5 text-xs font-medium text-primary-700">
            <i className="ri-flashlight-fill text-sm leading-none"></i>
            正在征集 · 每周更新高热度选题
          </span>

          <h1 className="mt-6 font-heading text-3xl font-bold leading-[1.25] text-foreground-950 md:text-5xl lg:text-[3.4rem] text-balance">
            让每一条线索，
            <span className="relative inline-block">
              <span className="relative z-10 text-primary-600">都有机会引爆全网</span>
              <span className="absolute bottom-1 left-0 z-0 h-3 w-full bg-accent-200/70 md:h-4"></span>
            </span>
          </h1>

          <p className="mt-6 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
            不知道投什么容易火？{brand.name}整理近期正在征集的高热度选题、爆款稿件的共同特征、
            投稿标题技巧与编辑偏好方向，让你的投稿更有机会被选中，并引发真正的关注。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <Link
              to="/topics"
              className="inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 px-6 py-3.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-compass-3-line text-base leading-none"></i>
              浏览高热度选题
            </Link>
            <Link
              to="/guide"
              className="inline-flex items-center justify-center gap-2 rounded-md border border-background-300 bg-background-50 px-6 py-3.5 text-sm font-medium text-foreground-800 transition-colors hover:border-foreground-400 whitespace-nowrap cursor-pointer"
            >
              学习爆款稿件特征
              <i className="ri-arrow-right-line text-base leading-none"></i>
            </Link>
          </div>

          <dl className="mt-10 grid grid-cols-2 gap-x-6 gap-y-5 border-t border-background-200 pt-8 sm:grid-cols-4">
            {stats.map((item) => (
              <div key={item.label}>
                <dt className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                  {item.value}
                </dt>
                <dd className="mt-1.5 text-xs leading-relaxed text-foreground-500">{item.label}</dd>
              </div>
            ))}
          </dl>
        </div>

        <div className="relative lg:col-span-5">
          <div className="relative mx-auto w-full max-w-md lg:max-w-none">
            <div className="overflow-hidden rounded-lg border border-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20editorial%20still%20life%20of%20a%20reporter%20desk%20with%20a%20notebook%2C%20pressed%20leaves%20and%20a%20vintage%20camera%2C%20soft%20morning%20window%20light%2C%20muted%20cream%20and%20terracotta%20tones%2C%20clean%20magazine%20composition%2C%20high%20detail%2C%20calm%20atmosphere&width=900&height=1120&seq=baodian-hero-main&orientation=portrait"
                alt="编辑桌面上的笔记本与相机，象征爆料投稿素材整理"
                title="爆料投稿 高热度选题参考 - 爆点投稿社素材桌"
                className="h-[420px] w-full object-cover object-top md:h-[540px]"
              />
            </div>

            <div className="absolute -bottom-6 -left-2 w-52 overflow-hidden rounded-lg border border-background-200 bg-background-50 p-0 md:-left-8 md:w-60">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20editorial%20close%20up%20of%20hands%20sorting%20printed%20documents%20and%20a%20phone%20showing%20a%20message%20thread%20on%20a%20wooden%20table%2C%20soft%20ambient%20light%2C%20muted%20cream%20and%20amber%20tones%2C%20documentary%20style%2C%20clean%20composition&width=800&height=600&seq=baodian-hero-detail&orientation=landscape"
                alt="双手整理稿件与手机聊天记录，展示可核实材料"
                title="投稿材料整理 - 高热度选题参考"
                className="h-32 w-full object-cover object-top md:h-36"
              />
              <div className="p-3">
                <p className="text-[11px] font-medium text-primary-600">材料齐全，过稿更快</p>
                <p className="mt-1 text-xs leading-snug text-foreground-600">
                  截图 · 合同 · 时间线，三样备齐再提交。
                </p>
              </div>
            </div>

            <div className="absolute -right-2 top-6 hidden rounded-md border border-background-200 bg-secondary-900 px-3.5 py-3 text-background-50 md:block">
              <p className="flex items-center gap-1.5 text-xs font-medium text-accent-400">
                <i className="ri-fire-line text-sm leading-none"></i>
                今日热投
              </p>
              <p className="mt-1.5 max-w-[9rem] font-heading text-sm font-semibold leading-snug">
                AI 换脸诈骗新套路
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="relative w-full overflow-hidden border-y border-background-200 bg-background-100 py-3">
        <div className="flex w-max animate-marquee items-center">
          {[0, 1].map((dup) => (
            <div key={dup} className="flex items-center">
              {["老旧小区电梯停工", "临期食品改标再卖", "骑手超时罚款内幕", "二房东跑路事件", "AI 换脸诈骗", "社区团购欠款"].map(
                (text) => (
                  <span
                    key={`${dup}-${text}`}
                    className="flex items-center gap-3 px-6 text-xs text-foreground-600"
                  >
                    <i className="ri-record-circle-line text-sm leading-none text-primary-500"></i>
                    {text}
                  </span>
                ),
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}